import { School } from '../types';

export const getSchoolName = (schoolId: string, schools: School[]) => {
  const school = schools.find((s) => s._id === schoolId);
  return school ? school.display_name : 'N/A';
};

export const getSchoolById = (schoolId: string, schools: School[]) => {
  return schools.find((s) => s._id === schoolId);
};

export const handleSchoolId = (schoolId: string | { _id: string } | null | undefined) => {
  if (!schoolId) return '';
  return typeof schoolId === 'string' ? schoolId : schoolId._id;
};

export const cn = (...classes: (string | undefined | null | false)[]) => {
  return classes.filter(Boolean).join(' ');
};

export const debounce = <T extends (...args: unknown[]) => unknown>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) => {
  let timeout: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};
